/**
 * Decode MSAL id_token JWT payload (no signature verification — for UX only; API validates the token).
 * @param {string} idToken
 * @returns {Record<string, unknown>|null}
 */
export function decodeMsalIdTokenPayload(idToken) {
  if (!idToken || typeof idToken !== "string") return null;
  const parts = idToken.split(".");
  if (parts.length < 2) return null;
  try {
    let base64 = parts[1].replace(/-/g, "+").replace(/_/g, "/");
    const pad = base64.length % 4;
    if (pad) base64 += new Array(5 - pad).join("=");
    const json = decodeURIComponent(
      window
        .atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

/**
 * Build fields for onboarding request + request-access URL from id_token claims.
 * @param {Record<string, unknown>} claims
 */
export function getEntraFieldsFromIdTokenClaims(claims) {
  if (!claims || typeof claims !== "object") return null;
  const email =
    (typeof claims.email === "string" && claims.email) ||
    (typeof claims.preferred_username === "string" && claims.preferred_username) ||
    (typeof claims.upn === "string" && claims.upn) ||
    "";
  return {
    email: email.trim(),
    oid: typeof claims.oid === "string" ? claims.oid : "",
    tid: typeof claims.tid === "string" ? claims.tid : "",
    name: typeof claims.name === "string" ? claims.name : "",
    preferredUsername:
      typeof claims.preferred_username === "string" ? claims.preferred_username : "",
  };
}
